import { apiInstanceFetch } from "../../util/api";
import { apiInstance } from "../../util/api-new";
import { setToast } from "../../util/toast";
import * as ActionType from "./loggedUser.type";

export const getAdminProfile = () => (dispatch) => {
  apiInstanceFetch
    .get("admin/admin/profile")
    .then((res) => {
      if (res.status) {
        dispatch({ type: ActionType.GET_LOGGED_USER, payload: res.user });
      } else {
        setToast("error", res.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
    });
};

export const getOrgMemberProfile = () => (dispatch) => {
  try {
    apiInstance.get("organization/members/profile").then((res) => {
      if (res.status) {
        dispatch({
          type: ActionType.GET_LOGGED_USER,
          payload: res.data.user,
        });
      }
    });
  } catch (error) {}
};

export const updateAdminDetails = (payload) => (dispatch) => {
  apiInstanceFetch
    .patch("admin/admin/updateProfile", payload)
    .then((res) => {
      if (res.status) {
        dispatch({
          type: ActionType.UPDATE_USER_DETAILS,
          payload: res.admin,
        });
      } else {
        setToast("error", res.error);
      }
    })
    .catch((error) => {
      setToast("error", error);
    });
};

export const updateMemberDetails = (memberId, payload) => (dispatch) => {
  apiInstance.put(`organization/members/${memberId}`, payload).then((res) => {
    dispatch({
      type: ActionType.UPDATE_USER_DETAILS,
      payload: res.data,
    });
  });
};
